import { floatRenderer } from '../../services/formatSvc';

const initialKpiState = {
  comment: null, estimate: null, fact: null, plan: null,
};

const kpiFieldLabels = {
  comment: 'Комментарий ',
  estimate: 'Прогноз ',
  fact: 'Факт ',
  factHalf: 'Факт конец полугодия ',
  fact02: 'Факт на 01.02.',
  fact03: 'Факт на 01.03.',
  fact04: 'Факт на 01.04.',
  fact05: 'Факт на 01.05.',
  fact06: 'Факт на 01.06.',
  fact07: 'Факт на 01.07.',
  fact08: 'Факт на 01.08.',
  fact09: 'Факт на 01.09.',
  fact10: 'Факт на 01.10.',
  fact11: 'Факт на 01.11.',
  fact12: 'Факт на 01.12.',
  factSemi: 'Факт промежуточного отчета ',
  plan: 'План ',
};

const mapUserName = (user) => `${user?.lastName || ''} ${user?.firstName || ''} ${user?.middleName || ''}`;

const getMappedEntry = (entry, changeDescr, oper) => ({
  createdOn: entry.createdOn,
  userName: mapUserName(entry.user),
  oper: oper || entry.oper,
  changeDescr,
});

const renderValue = (value, key) => {
  switch (key) {
    case 'comment':
      return value;
    default:
      return floatRenderer(value);
  }
};

const mapHistoryEntry = (entry) => {
  const result = [];

  if (entry.changes) {
    const { changes, year } = entry;

    const descrChanged = [];
    const descrRemoved = [];

    const previousState = changes.prevVal ? { ...changes.prevVal } : { ...initialKpiState };

    for (const [key, value] of Object.entries(changes.val)) {
      if (previousState[key] !== value) {
        if (value !== null) { descrChanged.push(`${kpiFieldLabels[key]}${year}: ${renderValue(value, key)}`); } else { descrRemoved.push(`${kpiFieldLabels[key]}${year}`); }
      }
    }

    if (descrChanged.length) { result.push(getMappedEntry(entry, descrChanged.join('\n'))); }
    if (descrRemoved.length) { result.push(getMappedEntry(entry, descrRemoved.join('\n'), 'Удаление')); }
  } else {
    result.push(entry);
  }

  return result;
};

export const mapResponseHistory = (responseHistory) => responseHistory.reduce((acc, entry) => [...acc, ...mapHistoryEntry(entry)], []);
